import LightGrayBgWrapper from "../../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import PreviewBannerImg from "../../../../../assets/images/SellerPortalImages/Settings/preview-banner.png"
import CreateStorePageCard from "../../../../../components/SellerPortalComponents/Settings/StoreSetting/CreateStorePageCard/CreateStorePageCard"
import { Col, Row } from "reactstrap"
import BackButton from "../../../../../components/common/BackButton/BackButton"

const CreateStorePage = () => {
  const data = [
    { img: PreviewBannerImg, title: "Default Theme", price: "Free" },
    { img: PreviewBannerImg, title: "Theme name", price: "$5.00" },
    { img: PreviewBannerImg, title: "Theme name", price: "$5.00" },
  ]

  return (
    <LightGrayBgWrapper>
      <BackButton />
      <div className="text-center fw-semibold fs-5">Create Store Page</div>
      <div className="fw-medium mt-3">Following are the different themes of Home page that you can choose for your store</div>

      <Row className="mt-3">
        {data.map((item, index) => (
          <Col>
            <CreateStorePageCard key={index} src={item.img} title={item.title} price={item.price} />
          </Col>
        ))}
      </Row>
    </LightGrayBgWrapper>
  )
}

export default CreateStorePage
